@let status = callStatus();

@if (visible) {

<content [requestStatus]="status">
  <div class="fields">
    <div class="field">
      <span>
        <strong>{{ field.props.label }}</strong>
      </span>
      <kt-preview-selection [field]="field"
                            [shorten]="field.props['shorten']"
                            [canRemove]="field.props['multiple']"
                            (remove)="removeSelection($event)" />
    </div>
  </div>
</content>
}